export default __webpack_public_path__ + "static/avatar-grid-a75653ee034e2d00b626841c27e587b0.svg";